import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chips } from '../../../../components/chips/chips';

interface NormativeBadgeProps {
  notApplicable?: boolean;
  skipped?: boolean;
  isNormative?: boolean;
}
export function SummaryNormativeBadge({
  notApplicable,
  isNormative,
  skipped,
}: NormativeBadgeProps) {
  const { t } = useTranslation();

  return (
    <>
      {(notApplicable && (
        <Chips
          color="info"
          label={t('assessment.ASSESSMENT_SUMMARY_NORMATIVE_NOT_APPLICABLE')}
          size="small"
          variant="filled"
        />
      )) ||
        (skipped && (
          <Chips
            color="warning"
            label={t('assessment.ID_MODULE_SKIPPED')}
            size="small"
            variant="filled"
          />
        )) ||
        (isNormative && (
          <Chips
            color="success"
            label={t('assessment.ASSESSMENT_SUMMARY_NORMATIVE_NORMAL')}
            size="small"
            variant="filled"
          />
        )) ||
        (typeof isNormative !== 'undefined' && !isNormative && (
          <Chips
            color="error"
            label={t('assessment.ASSESSMENT_SUMMARY_NORMATIVE_ABNORMAL')}
            size="small"
            variant="filled"
          />
        ))}
    </>
  );
}
